var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"svp-player-component"},[_c('div',{staticStyle:{"position":"relative"},attrs:{"id":_vm.playerElement.elementId}})]),_c('div',{attrs:{"id":_vm.gistId}})])}
var staticRenderFns = []

export { render, staticRenderFns }